import "./FullscreenLoader.css";

export function FullscreenLoader({ label = "Loading workspace…" }: { label?: string }) {
  return (
    <div className="fullscreen-loader" role="status" aria-live="polite">
      <span className="fullscreen-loader__ring" aria-hidden />
      <p className="fullscreen-loader__label">{label}</p>
    </div>
  );
}
